import React from "react";
import BaseNumberInput from "./baseNumberInput";
import { NumberInputProps } from "models/propTypes/wintFormPropsTypes";

const NumberInput: React.FC<NumberInputProps> = (props: NumberInputProps) => {
  return <BaseNumberInput {...props} type="number" data-testid={`${props.name}NumberInput`} />;
};

export default NumberInput;
